export default __webpack_public_path__ + "static/media/ConferenceOnlineIcon.9ed7d788.svg";